import styled from 'styled-components';
import { StyledPaymentPageCard } from './PaymentPage.styled';

export const StyledMonthlyCard = styled(StyledPaymentPageCard)`
    .subheader {
        display: flex;
        font-weight: 700;
        width: 100%;
        justify-content: center;
        position: relative;
        margin: 16px 0 13px;
        font-family: var(--bllink-font-secondary);

        .check-all {
            position: absolute;
            left: ${({ ltr }) => ltr ? '0' : ''};
            right: ${({ ltr }) => ltr ? '' : '0'};
            top: 4px;
        }
    }

    .month-item {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        justify-content: space-between;
        width: 100%;
        align-items: start;
        padding: 11px 0;
        border-bottom: 1px solid #F3F1FF;
        text-align: center;
        &:last-of-type {
          margin-bottom: 11px;
        }

        .currency-value {
            justify-self: flex-end;
        }

        .year-and-checkbox {
            display: flex;
            gap: 19px;
        }
    }

    @media screen and (max-width: 768px) {
        .payment-item {
            font-size: 14px;
        }
    }
`
